import React from "react"
import { SelectBox, Template } from "devextreme-react";
import { renderDropdownIcon } from "../../commonFunctions/commonFunctions";


function CustomSelectBox(props){
    return(
    <SelectBox
    {...props}
    ref={props.innerRef}
    showDropDownButton
    labelMode="floating"
    dropDownButtonTemplate="dropdownIcon"
    >
        <Template
            name="dropdownIcon"
            render={renderDropdownIcon}
        />
    </SelectBox>
    )
}

export default CustomSelectBox